import {
  ComponentProps,
  createContext,
  FC,
  ReactElement,
  useContext,
  useReducer
} from 'react';
import {
    selectedCheckBoxReducer,
  initialSelectedCheckBoxState
} from '@shared/context/reducers/SelectedCheckBoxReducer';
import { setSelectedCheckBox } from '@shared/context/actions/SelectedCheckBoxActions';
import { SelectedCheckBoxModel } from '@shared/context/mappers/SelectedCheckBoxTypesMapper';

interface SelectedCheckBoxInterface {
  readonly SelectedCheckBoxState: SelectedCheckBoxModel;
  readonly setSelectedCheckBoxData: (data: object) => void;
}

const SelectedCheckBoxContext = createContext<SelectedCheckBoxInterface>(
  {} as SelectedCheckBoxInterface
);

export const useSelectedCheckBoxContext = (): SelectedCheckBoxInterface =>
  useContext(SelectedCheckBoxContext);

export const SelectedCheckBoxProvider = ({
  children
}: ComponentProps<FC<any>> & {children: ReactElement}): JSX.Element => {
  const [SelectedCheckBoxState, dispatch] = useReducer( selectedCheckBoxReducer , initialSelectedCheckBoxState);

  const setSelectedCheckBoxData = (data: any): void => {
    setSelectedCheckBox(dispatch, data);
  };

  return (
    <SelectedCheckBoxContext.Provider
      value={{SelectedCheckBoxState, setSelectedCheckBoxData}}>
      {children}
    </SelectedCheckBoxContext.Provider>
  );
};
